import React, { useState, useEffect, useRef } from "react";
import { Modal, IconButton, Button, Typography, Tooltip, Box, Popper, Fade, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HeaderV2 from "../dms_common/HeaderV2";
import CustomTablewithTotalInfo from "../dms_common/CustomTablewithTotalInfo";
import BorderHeading from "../heading/BorderHeading";
import TextSwitcher, { TextSwitcherItemObject } from "../dms_common/TextSwitcher";
import CustomAccordianV2 from "../dms_common/CustomAccordianV2";
import { getViewOrderConfigV2 } from "../../features/viewOrder/ViewOrderConfig";
import { UOM } from "../../features/createSecondaryOrder/CreateSecondaryOrderType";
import "./OutletWiseAllocationModal.css";
import { ArrowBack } from "@mui/icons-material";
import { addToUomWiseAllocation, generateMergedRows, getOutletWiseAllocationAccordianMetadata, GlobalNormalizedStockMap, OrderBodyForPayloadMap, OrderWiseAllocationData, StockAllocationRowData, verifyAllocation } from "../../features/secondaryOrder/ManageStockAllocationUtils";
import OrderStatusCell from "../dms_common/OrderStatusCell";
import { orderStatusConfig } from "../../types/types";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import { performUomConversion } from "../../services/catalogueService";
import { getDataFromLocalDb } from "../../services/dbService";
import CustomGenericModal from "../dms_common/CustomGenericModal";
import { GenericModal, initialGenericModalProps } from "../../features/viewOrder/ViewOrderUtils";
import { getGenericModalProps } from "../loadouts/LoadoutUtils";
import { filterData, searchWithStatusFilter } from "../dms_common/DmsCommonServices";
import StarsRoundedIcon from "@mui/icons-material/StarsRounded";
import CustomTablewithTotalInfoV2 from "../dms_common/CustomTablewithTotalInfoV2";
import RenderSvg from "../renderSvg/RenderSvg";


interface OutletWiseAllocationModalProps {
  statusConfig: orderStatusConfig[];
  open: boolean;
  onClose: () => void;
  productData?: StockAllocationRowData;
  rowData: OrderWiseAllocationData[];
  setManageStockAllocationRows: React.Dispatch<React.SetStateAction<StockAllocationRowData[]>>;
  setOrderBodyForPayload: React.Dispatch<React.SetStateAction<any>>
  orderBodyForPayload: any;
  handleReset: (batchCode: string) => void;
  setCompleteOrderBody:  React.Dispatch<React.SetStateAction<OrderBodyForPayloadMap>>;
  completeOrderBody: OrderBodyForPayloadMap;
  setManageStockAllocationData: React.Dispatch<React.SetStateAction<StockAllocationRowData[]>>;
  showResetButton?: boolean;
  showSaveButton?: boolean;
  orderUomCheck?:string;
  globalNormalizedStockMap?: GlobalNormalizedStockMap;
  products?: any;
  setGlobalNormalizedStockMap?: React.Dispatch<React.SetStateAction<GlobalNormalizedStockMap | undefined>>;
}

const OutletWiseAllocationModal: React.FC<OutletWiseAllocationModalProps> = ({
  statusConfig,
  open,
  onClose,
  productData,
  rowData,
  setManageStockAllocationRows,
  setOrderBodyForPayload,
  orderBodyForPayload,
  handleReset,
  setCompleteOrderBody,
  completeOrderBody,
  setManageStockAllocationData,
  showResetButton = true,
  showSaveButton = true,
  orderUomCheck,
  globalNormalizedStockMap,
  products,
  setGlobalNormalizedStockMap
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [rows, setRows] = useState(rowData);
  const [filteredRows, setFilteredRows] = useState<any[]>([]);
  
  const [isEditing, setIsEditing] = useState(true);
  const [customAccodionData, setCustomAccordionData] = useState<any>({});
  const [showReplaceableSkuDropdown, setShowReplaceableSkuDropdown] = useState(false);
  const totalStockOfSku = useRef<number>(0);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const textSwitcherItems: TextSwitcherItemObject[] = [
    {
      label: "Please note:",
      text: "Remaining qty will auto-replace with the mapped SKU in the product replacement",
      svgIcon: "disclaimerIcon",
      itemStyles: {
        container: {
          backgroundColor: "#FFF3DB",
          padding: "12px 16px",
          borderRadius: "8px",
          borderLeft: "4px solid #f29c38",
        },
        label: {
          fontWeight: "600",
          color: "#CC8034",
        },
        text: {
          color: "#CC8034",
          fontSize: "14px",
        },
        svg: {
          color: "#F29C38",
          width: "16px",
          height: "16px",
        },
      },
    },
  ];
  useEffect(() => {
    if (!productData) return;

    const keyAccountsCount = productData.outletList?.filter(o => o.isKeyAccount).length ?? 0;

    setCustomAccordionData({
      totalOutlets: productData.outletList?.length ?? 0,
      keyAccounts: keyAccountsCount,
      totalOrderedCases: productData.orderedCases,
      totalOrderedPieces: productData.orderedPieces,
      totalOrderedOthers: productData.orderedOthers,
      stockExceedingCases: productData.stockExceedingCases,
      stockExceedingPieces: productData.stockExceedingPieces,
      stockExceedingOthers: productData.stockExceedingOthers,
      availableCases: productData.mainSkuAvailableCases,
      availablePieces: productData.mainSkuAvailablePieces,
      availableOthers: productData.mainSkuAvailableOther,
      totalOrderedQuantity: productData.totalOrderedQuantity,
      totalAvailableQuantity: productData.totalAvailableQuantity,
      stockExceedingQuantity: productData.totalStockExceedingQuantity,
      replacementSkuAvailable: productData.replacementSkuAvailable,
    });

    totalStockOfSku.current = productData.totalAvailableQuantity
    
  }, [productData]);

  useEffect(() => {
    if (open) {
      setIsVisible(true);
    }
  }, [open]);

  useEffect(() => {
    setRows(rowData ?? []);
  }, [rowData]);

  const handleClose = () => {
    setIsVisible(false);
    setAnchorEl(null);
    setActiveRow(null);
    setTimeout(() => {
      onClose();
    }, 300); 
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchValue(newValue);
  };

  const handleRefresh = () => {
    
  };

  const resetSearch = () => {
    setSearchValue("");
  };

  useEffect(() => {
    let filtered = filterData([...rows], searchValue?.toLowerCase(), searchWithStatusFilter)
  
      setFilteredRows(filtered);
  }, [rows, searchValue, searchWithStatusFilter]);

const handleDistributeEquallyClick = () => {
  if (!rows.length) return;

  // 1) compute ordered pieces per row
  const rowInfos = rows.map((row) => {
    const orderTotalPieces =
      (row.orderedCases || 0) * (row.caseToPieceQty || 0) +
      (row.orderedOthers || 0) * (row.otherToPieceQty || 0) +
      (row.orderedPieces || 0);

    return {
      row,
      orderTotalPieces,
      provisionalAllocatedPieces: 0,
      cappedAllocatedPieces: 0,
    };
  });

  const totalOrderedQuantity = rowInfos.reduce((s, r) => s + r.orderTotalPieces, 0);
  if (totalOrderedQuantity === 0) return;

  // 2) compute proportional allocation in pieces (floor, cap at ordered quantity)
  const totalStockPieces = totalStockOfSku.current;
  rowInfos.forEach((info) => {
    const contributionPct = info.orderTotalPieces / totalOrderedQuantity;
    info.provisionalAllocatedPieces = Math.floor(contributionPct * totalStockPieces);
    info.cappedAllocatedPieces = Math.min(info.provisionalAllocatedPieces, info.orderTotalPieces);
  });

  // 3) convert capped pieces back to Cases -> Others -> Pieces and build new rows
  const newRows = rowInfos.map((info) => {
    const row = info.row;
    const allocatedPiecesTotal = info.cappedAllocatedPieces;

    const caseToPiece = row.caseToPieceQty || 1;
    const otherToPiece = row.otherToPieceQty || 0;

    // Allocate main first
    let remainingPieces = allocatedPiecesTotal;
    const mainAllocatedCases = caseToPiece > 0 ? Math.floor(remainingPieces / caseToPiece) : 0;
    remainingPieces -= mainAllocatedCases * caseToPiece;

    let mainAllocatedOthers = 0;
    if (otherToPiece > 0) {
      mainAllocatedOthers = Math.floor(remainingPieces / otherToPiece);
      remainingPieces -= mainAllocatedOthers * otherToPiece;
    }

    const mainAllocatedPieces = remainingPieces;
    remainingPieces = 0;

    const mainNormalizedAllocatedQuantity =
      mainAllocatedCases * caseToPiece +
      mainAllocatedOthers * otherToPiece +
      mainAllocatedPieces;

    // For this proportional allocation, we assume no replacements yet (empty map)
    const replacementAllocated: Record<string, number> = {};

    const totalAllocatedQuantity = mainNormalizedAllocatedQuantity; // main + replacement (currently only main)

    // remaining to fulfill the order (ordered - allocated)
    const totalStockExceedingQuantity = Math.max((row.totalOrderedQuantity || 0) - totalAllocatedQuantity, 0);

    const {
      convertedCaseQty: remainingCaseQty,
      convertedOtherQty: remainingOtherQty,
      convertedPieceQty: remainingPieceQty,
    } = performUomConversion(
      0,
      0,
      totalStockExceedingQuantity,
      row.uom,
      row.caseToPieceQty,
      row.otherToPieceQty,
      0,
      0,
      0,
      true,
      row.otherUnitName
    );

    return {
      ...row,
      mainAllocatedCases,
      mainAllocatedOthers,
      mainAllocatedPieces,
      replacementAllocated,
      allocatedCases: mainAllocatedCases, // sum of main + replacements (here replacements = 0)
      allocatedOthers: mainAllocatedOthers,
      allocatedPieces: mainAllocatedPieces,
      totalAllocatedQuantity,
      stockExceedingCases: remainingCaseQty,
      stockExceedingPieces: remainingPieceQty,
      stockExceedingOthers: remainingOtherQty,
      totalStockExceedingQuantity,
    };
  });

  setRows(newRows);
};



  const handleResetAllocation = () => {
    setRows(prevRows =>
      prevRows.map(row => ({
        ...row,
        allocatedCases: row.initialAllocatedCases,
        allocatedPieces: row.initialAllocatedPieces,
        allocatedOthers: row.initialAllocatedOthers,
        totalAllocatedQuantity: row.initialAllocatedCases * row.caseToPieceQty +
                               row.initialAllocatedOthers * row.otherToPieceQty +
                               row.initialAllocatedPieces,
        stockExceedingCases: row.initialStockExceedingCases,
        stockExceedingOthers: row.initialStockExceedingOthers,
        stockExceedingPieces: row.initialStockExceedingPieces,
        totalStockExceedingQuantity: row.initialStockExceedingCases * row.caseToPieceQty +
                                      row.initialAllocatedOthers * row.otherToPieceQty + 
                                      row.initialStockExceedingPieces,
        mainAllocatedCases: row.initialMainAllocatedCases,
        mainAllocatedOthers: row.initialMainAllocatedOthers,
        mainAllocatedPieces: row.initialMainAllocatedPieces,
        replacementAllocated: row.initialReplacementAllocated,
        mergedRows: row.initialMergedRows

      }))
    );
  };

const handleQuantityChange = (
  paramRow: OrderWiseAllocationData,
  changedQuantity: number,
  type: UOM
) => {
  if (changedQuantity < 0) return;

  const quantityKey =
    type === UOM.CASE
      ? "allocatedCases"
      : type === UOM.OTHER
      ? "allocatedOthers"
      : "allocatedPieces";

  // Build updated row
  const updatedRow = { ...paramRow, [quantityKey]: changedQuantity };

  // Helpers: requested normalized pieces and ordered normalized
  const requestedNormalized =
    (updatedRow.allocatedCases || 0) * (updatedRow.caseToPieceQty || 0) +
    (updatedRow.allocatedOthers || 0) * (updatedRow.otherToPieceQty || 0) +
    (updatedRow.allocatedPieces || 0);

  const orderedNormalized =
    (updatedRow.orderedCases || 0) * (updatedRow.caseToPieceQty || 0) +
    (updatedRow.orderedOthers || 0) * (updatedRow.otherToPieceQty || 0) +
    (updatedRow.orderedPieces || 0);

  if (requestedNormalized > orderedNormalized) return;

  // aggregated across all rows must not exceed totalStockOfSku.current
  const aggregatedTotalAllocated = rows.reduce((sum, r) => {
    const rr = r.id === updatedRow.id ? updatedRow : r;
    return (
      sum +
      (rr.allocatedCases || 0) * (rr.caseToPieceQty || 0) +
      (rr.allocatedOthers || 0) * (rr.otherToPieceQty || 0) +
      (rr.allocatedPieces || 0)
    );
  }, 0);

  if (aggregatedTotalAllocated > totalStockOfSku.current) {
    console.warn(
      `Cannot allocate. Total allocated quantity (${aggregatedTotalAllocated}) exceeds total stock (${totalStockOfSku.current}).`
    );
    return;
  }

  // read mapping (main SKU record) but DO NOT mutate it
  const batchKey = productData?.batchCode ?? "";
  const mapping = globalNormalizedStockMap?.get(batchKey);
  if (!mapping) return;

  // compute previous allocations for this order (virtual free-up)
  const orderId = String(paramRow.id);
  const prevMainForOrder = Number(mapping.mainAllocatedByOrder?.[orderId] ?? 0);
  const prevReplMap: Record<string, number> = { ...(mapping.replacementSkuAllocated?.[orderId] ?? {}) };

  // Available main for this recalculation = current remainingReplacementQuantity + prevMainForOrder
  const availableMainNow = Math.max(0, Number(mapping.remainingReplacementQuantity ?? 0) + prevMainForOrder);

  // 1) allocate from main (virtually)
  let remainingToAllocate = requestedNormalized;
  const mainAllocatedFromMain = Math.min(availableMainNow, remainingToAllocate);
  remainingToAllocate -= mainAllocatedFromMain;

  // 2) allocate from replacements (PRIORITY BY EXPIRY: earliest expiry first), but do NOT write global state
  const replacementAllocated: Record<string, number> = {};
  let totalReplacementAllocatedCases = 0;
  let totalReplacementAllocatedPieces = 0;
  let totalReplacementAllocatedOthers = 0;
  let totalReplacementAllocated = 0;

  // Build replacement list and sort by minExpiryDate ascending (earliest expiry first)
  const replListRaw = Array.isArray(mapping.replacementSku) ? mapping.replacementSku.slice() : [];
  const replListSorted = replListRaw.sort((a, b) => {
    const da = globalNormalizedStockMap?.get(a)?.minExpiryDate;
    const db = globalNormalizedStockMap?.get(b)?.minExpiryDate;
    const ta = da ? new Date(da).getTime() : Infinity;
    const tb = db ? new Date(db).getTime() : Infinity;
    return ta - tb;
  });


  for (const replCode of replListSorted) {
    if (remainingToAllocate <= 0) break;

    // consider replacement availability = repl.remainingReplacementQuantity + previously-allocated-for-this-order
    const replRecord = globalNormalizedStockMap?.get(replCode);
    const replRemaining = Math.max(0, Number(replRecord?.remainingReplacementQuantity ?? 0));
    const prevAllocatedForOrderThisRepl = Number(prevReplMap[replCode] ?? 0);
    const replAvailableNow = replRemaining + prevAllocatedForOrderThisRepl;

    if (replAvailableNow <= 0) continue;

    const take = Math.min(replAvailableNow, remainingToAllocate);
    replacementAllocated[replCode] = take;
    totalReplacementAllocated += take

    // UoM breakdown for replacements (for UI)
    const bd = addToUomWiseAllocation(products[replCode], take, orderUomCheck ?? "true");
    totalReplacementAllocatedCases += bd.cs ?? 0;
    totalReplacementAllocatedPieces += bd.pi ?? 0;
    totalReplacementAllocatedOthers += bd.oth ?? 0;

    remainingToAllocate -= take;
  }

  // 3) compute UoM breakdown for main allocation (for UI)
  const mainBreakdown = addToUomWiseAllocation(products[batchKey], mainAllocatedFromMain, orderUomCheck ?? "true");
  const mainAllocatedCases = mainBreakdown.cs ?? 0;
  const mainAllocatedPieces = mainBreakdown.pi ?? 0;
  const mainAllocatedOthers = mainBreakdown.oth ?? 0;

  // 4) final allocated uom-wise = main + replacement
  const totalAllocated = mainAllocatedFromMain + totalReplacementAllocated
  const totalAllocatedBreakdown = addToUomWiseAllocation(products[batchKey], totalAllocated, orderUomCheck ?? "true")

  // 6) remaining shortage (based on actual allocation)
  const actualShortage = Math.max(orderedNormalized - totalAllocated, 0);

  // 7) compute stockExceeding fields for UI from actualShortage
  let { caseToPieceQty, otherToPieceQty, uom, otherUnitName } = updatedRow;
  if (orderUomCheck === "true") uom = updatedRow?.uom ?? "all";
  else uom = "all";

  const { convertedCaseQty: uiRemainingCaseQty, convertedOtherQty: uiRemainingOtherQty, convertedPieceQty: uiRemainingPieceQty } =
    performUomConversion(
      0,
      0,
      actualShortage,
      uom,
      caseToPieceQty,
      otherToPieceQty,
      0,
      0,
      0,
      true,
      otherUnitName
    );

  // 8) totalAllocatedQuantity for the row (normalized pieces we actually allocated)
  const totalAllocatedQuantityForRow = totalAllocated;

  const newMergedRows = generateMergedRows(batchKey, mainBreakdown, replacementAllocated, products, orderUomCheck ?? "true");

  // 9) update only rows (do not mutate globalNormalizedStockMap)
  setRows((prevRows) =>
    prevRows.map((r) =>
      r.id === updatedRow.id
        ? {
            ...updatedRow,

            // main allocation UoM (from mainBreakdown)
            mainAllocatedCases,
            mainAllocatedPieces,
            mainAllocatedOthers,

            // replacementAllocated map (normalized pieces per replacement SKU)
            replacementAllocated,

            // final allocated sums
            allocatedCases: totalAllocatedBreakdown.cs,
            allocatedPieces: totalAllocatedBreakdown.pi,
            allocatedOthers: totalAllocatedBreakdown.oth,

            // normalized total allocated
            totalAllocatedQuantity: totalAllocatedQuantityForRow,

            // stock exceeding based on actual allocation
            stockExceedingCases: uiRemainingCaseQty,
            stockExceedingOthers: uiRemainingOtherQty,
            stockExceedingPieces: uiRemainingPieceQty,
            totalStockExceedingQuantity: actualShortage,

            mergedRows: newMergedRows
          }
        : r
    )
  );
};


  const hasAnyChanges = (): boolean => {
    if (!rows) return false;
    return rows.some((row) => {
      return (
        row.allocatedCases !== row.initialAllocatedCases ||
        row.allocatedPieces !== row.initialAllocatedPieces ||
        row.allocatedOthers !== row.initialAllocatedOthers
      );
    });
  };
const handleSaveAllocation = async () => {
  if (!hasAnyChanges()) return
  if (!orderBodyForPayload || !completeOrderBody) return;
  
  const { auto: existingAuto, manual: existingManual } = orderBodyForPayload;

  const newAuto = [...existingAuto];
  const newManual = [...existingManual];

  // Clone the orderBody to update
  const newOrderBody = { ...completeOrderBody };

  for (const row of rows) {
    const hasManualAllocation =
      row.allocatedCases !== row.initialAllocatedCases ||
      row.allocatedPieces !== row.initialAllocatedPieces ||
      row.allocatedOthers !== row.initialAllocatedOthers;

    // --- Update payload ---
    if (hasManualAllocation) {
      const autoIndex = newAuto.indexOf(row.orderNumber);
      if (autoIndex !== -1) newAuto.splice(autoIndex, 1);

      const manualOrderIndex = newManual.findIndex(
        (o) => o.orderNumber === row.orderNumber
      );

      const nq = row.mainAllocatedCases * row.caseToPieceQty + row.mainAllocatedOthers * row.otherToPieceQty + row.mainAllocatedPieces
      const replNq = Object.values(row.replacementAllocated ?? {}).reduce(
        (sum, qty) => sum + (Number(qty) || 0),
        0
      );

      const totalNq = nq + replNq


      const orderDetailNode = {
        batchCode: row.batchCode,
        skuCode: row.batchCode,
        caseQuantity: 0,
        pieceQuantity: totalNq,
        otherUnitQuantity: 0,
        type: "normal"
      };

      if (manualOrderIndex !== -1) {
        const existing = newManual.splice(manualOrderIndex, 1)[0];

        const existingBatchIndex = existing.orderDetails.findIndex(
          (od: any) => od.batchCode === row.batchCode
        );

        if (existingBatchIndex !== -1) {
          existing.orderDetails[existingBatchIndex] = orderDetailNode;
        } else {
          existing.orderDetails.push(orderDetailNode);
        }

        newManual.push(existing);
      } else {
        newManual.push({
          orderNumber: row.orderNumber,
          orderDetails: [orderDetailNode],
        });
      }

      //update complete order Body
      const orderNode = newOrderBody[row.orderNumber];
      if (orderNode) {
        const existingBatch = orderNode.orderDetails[row.batchCode];
        orderNode.orderDetails[row.batchCode] = {
          ...existingBatch,
          batchCode: row.batchCode,
          skuCode: row.batchCode,
          allocatedCases: row.allocatedCases,
          allocatedPieces: row.allocatedPieces,
          allocatedOthers: row.allocatedOthers,
          hasBeenManuallyAllocated: hasManualAllocation,
        };
      }
    }
  }

  const updatedPayload = { auto: newAuto, manual: newManual };
    const { uomConversion } = ConfigDictionary;

  //handle stock update in global stock map due to changes in the allocted quantities
  try {
    await verifyAllocation(updatedPayload)
  } catch (error){
    setGenericModalProps(
      getGenericModalProps("error","Stock Data has changed. Please refresh.")
    ) 
    return;
  }

  setOrderBodyForPayload(updatedPayload);
  setCompleteOrderBody(newOrderBody);
  console.log("newPayload", updatedPayload)
  updateGlobalStock()

  handleClose();
};

const updateGlobalStock = () => {
  if (!globalNormalizedStockMap) return;

  // 1) clone map so React can detect change
  const newMap = new Map(globalNormalizedStockMap);

  const key = productData?.batchCode ?? "";
  const currentSku = newMap.get(key);
  if (!currentSku) return;

  // 2) clone sku object (shallow). Deep-clone nested objects you will mutate.
  const clonedSku = {
    ...currentSku,
    // clone nested maps/objects that you will modify:
    replacementSkuAllocated: { ...(currentSku.replacementSkuAllocated ?? {}) },
    mainAllocatedByOrder: { ...(currentSku.mainAllocatedByOrder ?? {}) },
  };

  // 3) perform updates on clonedSku
  for (const row of rows) {
    const hasManualAllocation =
      row.allocatedCases !== row.initialAllocatedCases ||
      row.allocatedPieces !== row.initialAllocatedPieces ||
      row.allocatedOthers !== row.initialAllocatedOthers;
    if (hasManualAllocation){
      // ... your logic, but mutate clonedSku not currentSku ...
      const orderId = row.id;
      const currentReplacementSkuAllocated = clonedSku.replacementSkuAllocated[orderId] ?? {};
      //freeup allocated replacements
      for (const [repl, qty] of Object.entries(currentReplacementSkuAllocated)) {
        const replSku = newMap.get(repl);
        if (replSku) {
          // IMPORTANT: clone the replacement SKU before mutating it as well
          const clonedReplSku = { ...replSku };
          clonedReplSku.allocatedReplacementQuantity = (clonedReplSku.allocatedReplacementQuantity ?? 0) - qty;
          clonedReplSku.remainingReplacementQuantity = (clonedReplSku.remainingReplacementQuantity ?? 0) + qty;
          newMap.set(repl, clonedReplSku);
        }
      }
      clonedSku.replacementSkuAllocated[orderId] = {};

      // compute allocations correctly (use row.allocated* consistently)
      const newAllocation =
        row.allocatedCases * row.caseToPieceQty +
        row.allocatedOthers * row.otherToPieceQty +
        row.allocatedPieces;

      //freeup
      clonedSku.remainingReplacementQuantity += clonedSku.mainAllocatedByOrder[orderId]
      clonedSku.replacementQuantity += clonedSku.mainAllocatedByOrder[orderId]
      
      //update
      clonedSku.mainAllocatedByOrder[orderId] = row.mainAllocatedCases * row.caseToPieceQty + row.mainAllocatedOthers * row.otherToPieceQty + row.mainAllocatedPieces

      //occupy
      clonedSku.remainingReplacementQuantity -= clonedSku.mainAllocatedByOrder[orderId]
      clonedSku.replacementQuantity -= clonedSku.mainAllocatedByOrder[orderId]

      //occupy
      const replacementSkuAllocated = { ...(row.replacementAllocated ?? {}) };
      let totalReplacementAllocated = 0
      for (const [repl, qty] of Object.entries(replacementSkuAllocated)) {
        const replSku = newMap.get(repl);
        if (replSku) {
          const clonedReplSku = { ...replSku };
          totalReplacementAllocated += qty
          clonedReplSku.allocatedReplacementQuantity = (clonedReplSku.allocatedReplacementQuantity ?? 0) + qty;
          clonedReplSku.remainingReplacementQuantity = (clonedReplSku.remainingReplacementQuantity ?? 0) - qty;
          newMap.set(repl, clonedReplSku);
        }
      }
      clonedSku.replacementSkuAllocated[orderId] = replacementSkuAllocated
      clonedSku.hasCompletedAllocation = true

      let totalMainAllocated = 0
      for (const [orderId, qty] of Object.entries(clonedSku.mainAllocatedByOrder)){
        totalMainAllocated += qty
      }
      clonedSku.mainAllocatedQuantity = totalMainAllocated
      clonedSku.oversoldQuantity = (clonedSku.totalOrderedQuantity - (clonedSku.mainAllocatedQuantity + totalReplacementAllocated))
    }
  }

  // 4) set updated sku back into cloned map and update state
  newMap.set(key, clonedSku);
  setGlobalNormalizedStockMap?.(newMap);
};



const updateManageStockAllocationRows = (updatedOrders: OrderWiseAllocationData[]) => {
  setManageStockAllocationRows((prevRows) =>
    prevRows.map((batchRow) => {
      // Find updated orders belonging to this batchCode
      const matchingOrders = updatedOrders.filter(
        (order) => order.batchCode === batchRow.batchCode
      );

      if (matchingOrders.length === 0) return batchRow;

      const updatedOrderArray = batchRow.order.map((orderRow: any) => {
        const updatedOrder = matchingOrders.find((o) => o.id === orderRow.id);
        if (!updatedOrder) return orderRow;

        const quantityChanged =
          updatedOrder.allocatedCases !== updatedOrder.initialAllocatedCases ||
          updatedOrder.allocatedPieces !== updatedOrder.initialAllocatedPieces ||
          updatedOrder.allocatedOthers !== updatedOrder.initialAllocatedOthers;

        if (!quantityChanged) return orderRow;

        // Update allocated quantities
        const newAllocatedCases = updatedOrder.allocatedCases;
        const newAllocatedPieces = updatedOrder.allocatedPieces;
        const newAllocatedOthers = updatedOrder.allocatedOthers;

        // Update orderDetails inside the original order
        const updatedOrderDetails = orderRow.orderDetails.map((od: any) => {
          if (od.batchCode === batchRow.batchCode) {
            return {
              ...od,
              allocatedCases: newAllocatedCases,
              allocatedPieces: newAllocatedPieces,
              allocatedOthers: newAllocatedOthers,
              hasBeenManuallyAllocated: true,
            };
          }
          return od;
        });

        return {
          ...orderRow,
          orderDetails: updatedOrderDetails, 
        };
      });

      let sumAllocatedCases = 0;
      let sumAllocatedPieces = 0;
      let sumAllocatedOthers = 0;
      let sumTotalAllocated = 0;

      for (const orderRow of updatedOrderArray) {
        const ods = orderRow.orderDetails ?? [];
        for (const od of ods) {
          if (od.batchCode === batchRow.batchCode) {
            let ac;
            let ap;
            let ao;

            if (od.hasBeenManuallyAllocated){
              ac = Number(od.allocatedCases);
              ap = Number(od.allocatedPieces);
              ao = Number(od.allocatedOthers);
            } else {
              ac = Number(od.initialFifoAllocatedCases);
              ap = Number(od.initialFifoAllocatedPieces)
              ao = Number(od.initialFifoAllocatedOthers)
            }
            sumAllocatedCases += ac;
            sumAllocatedPieces += ap;
            sumAllocatedOthers += ao;
            sumTotalAllocated += ac + ap + ao;
          }
        }
      }

      // 3) produce new batchRow with updated header allocated totals.
      // Leave stockExceeding* fields unchanged (unless you want to recompute them)
      return {
        ...batchRow,
        order: updatedOrderArray,
        allocatedCases: sumAllocatedCases,
        allocatedPieces: sumAllocatedPieces,
        allocatedOthers: sumAllocatedOthers,
        totalAllocatedQuantity: sumTotalAllocated,
        hasCompletedAllocation: true,
      } as StockAllocationRowData;
    })
  );
 setManageStockAllocationData((prevRows) =>
    prevRows.map((batchRow) => {
      // Find updated orders belonging to this batchCode
      const matchingOrders = updatedOrders.filter(
        (order) => order.batchCode === batchRow.batchCode
      );

      if (matchingOrders.length === 0) return batchRow;

      const updatedOrderArray = batchRow.order.map((orderRow: any) => {
        const updatedOrder = matchingOrders.find((o) => o.id === orderRow.id);
        if (!updatedOrder) return orderRow;

        const quantityChanged =
          updatedOrder.allocatedCases !== updatedOrder.initialAllocatedCases ||
          updatedOrder.allocatedPieces !== updatedOrder.initialAllocatedPieces ||
          updatedOrder.allocatedOthers !== updatedOrder.initialAllocatedOthers;

        if (!quantityChanged) return orderRow;

        // Update allocated quantities
        const newAllocatedCases = updatedOrder.allocatedCases;
        const newAllocatedPieces = updatedOrder.allocatedPieces;
        const newAllocatedOthers = updatedOrder.allocatedOthers;

        // Update orderDetails inside the original order
        const updatedOrderDetails = orderRow.orderDetails.map((od: any) => {
          if (od.batchCode === batchRow.batchCode) {
            return {
              ...od,
              allocatedCases: newAllocatedCases,
              allocatedPieces: newAllocatedPieces,
              allocatedOthers: newAllocatedOthers,
              hasBeenManuallyAllocated: true,
            };
          }
          return od;
        });

        return {
          ...orderRow,
          orderDetails: updatedOrderDetails, 
        };
      });

      return { ...batchRow, order: updatedOrderArray, hasCompletedAllocation: true };
    })
  );
};

  const [hasAnyRemainingQuantity, setHasAnyRemainingQuantity] = useState<boolean>(false);

  useEffect(() => {
    const hasRemaingQuantity = rows.some((row) => row.totalStockExceedingQuantity !== 0)
    setHasAnyRemainingQuantity(hasRemaingQuantity);
  }, [rows])

  const handleOnBlur = (paramRow: any) => {
  };


  const handleRemove = (paramRow: any) => {
    
  };

  const handlePromotionModalVisibility = (paramRow: any) => {
    
  };

  const updateQuantityAndBlur = async (
    paramRow: any,
    newQuantity: number,
    type: UOM
  ) => {
    handleQuantityChange(paramRow, newQuantity, type);
  };

  const handleEditClick = async () => {
    setIsEditing(!isEditing);
  };

  const canEditOrder = () => true;

  
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const currency = ConfigDictionary?.currency;
  
  const [activeRow, setActiveRow] = useState<any>(null)

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>, row: OrderWiseAllocationData) => {
    if (activeRow?.id === row.id) {
      setActiveRow(null);
      setAnchorEl(null);
    } else {
      setActiveRow(row);
      setAnchorEl(event.currentTarget);
    }
  };

  useEffect(() => {
    if (!activeRow) return; // nothing to update
    const updatedRow = rows.find(r => r.id === activeRow.id); // or any unique id
    if (!updatedRow) return;
    setActiveRow(updatedRow)
  }, [rows]);

  const popoverOpen = Boolean(anchorEl);

  const id = open ? 'simple-popper' : undefined;


  const viewOrderConfig = getViewOrderConfigV2(
    handleQuantityChange,
    handleOnBlur,
    handleRemove,
    handlePromotionModalVisibility,
    false, 
    {}, // TableHeaders
    false, 
    false, 
    false, 
    false, 
    isEditing,
    setIsEditing,
    updateQuantityAndBlur,
    handleEditClick,
    canEditOrder()
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center'
      }}
      className="outlet-wise-allocation-modal-container"
    >
     
      <div
        className={`outlet-wise-allocation-modal ${isVisible ? 'slide-up' : 'slide-down'}`}
        style={{
          width: '100%',
          maxWidth: '100vw',
          height: '85vh',
          backgroundColor: '#ffffff',
          borderRadius: '16px 16px 0 0',
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          modalOpen={genericModalProps?.open}
          onClose={() => setGenericModalProps(initialGenericModalProps)}
        />
        {/* Header Section */}
        <div className="modal-header-stock" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px' }}>
          <Typography variant="h6" sx={{ color: '#252525', fontSize: '16px' }}>
          <IconButton onClick={handleClose} size="small">
              <ArrowBack sx={{ fontSize: 20, color: '#333' }} />
            </IconButton>
            <span style={{ fontWeight: 600, fontSize: '16px' }}>Manual stock adjustment :</span>
            <span style={{ fontWeight: 500, marginLeft: 6, fontSize: '16px' }}>Outlet wise allocation</span>
          </Typography>
            <IconButton 
              onClick={handleClose}
              sx={{ 
                color: '#666',
                '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' }
              }}
            >
              <CloseIcon />
            </IconButton>
        </div>

        {/* Content Section */}
        <div className="modal-content" style={{ flex: 1, padding: '0px 24px', display: 'flex', flexDirection: 'column',overflow: 'hidden', backgroundColor: '#fff' }}>
          {/* Product Info Header with Border Box */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            borderRadius: '8px', 
            border: '1px solid #E7E7E7', 
            padding: '10px',
            backgroundColor: '#FFF'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: 500, color: '#333', marginBottom: '4px', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span>{productData?.skuName}</span>
                  <span>({productData?.skuCode})</span>
                  <span style={{color:'#888'}}>Batch ID:</span>
                  <span>{productData?.batchId ?? "N/A"}</span>
                  <span style={{color:'#EC6C6C'}}>Expiry: {productData?.minExpiryDate ? productData.minExpiryDate.toLocaleDateString() : "N/A"}</span>
                  {/* Partially allocated status */}
                  <OrderStatusCell
                    orderStatusConfig={statusConfig}
                    statusId={productData?.status ?? "Out of stock"}
                  />
                </Typography>
              </div>
            </div>

            {/* CustomAccordianV2 with Replaceable SKU Info */}
            <div style={{ marginTop: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <div style={{ flex: 1 }}>
                  <CustomAccordianV2
                    metaData1={getOutletWiseAllocationAccordianMetadata()}
                    data1={customAccodionData}
                    showMoreDetails={false}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="data-grid-header">
            <HeaderV2
          title={"Outlet wise allocation"}
                resetSearch={false}
                textSwitcherItems={textSwitcherItems}
                searchFunction={handleSearchValueChange}
                showDistributeButton={false}
                onDistributeClick={handleDistributeEquallyClick}
                distributeButtonLabel="Proportional Distribution"
                showNoteBanner={false}
                handleCheckListClick={() => setShowReplaceableSkuDropdown(true)}
              />
            </div>

          {/* Data Grid Section */}
          <div className="data-grid-section" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div className="data-grid-container" style={{ 
              flex: 1, 
              overflow: 'hidden',
              height: '100%',
              width: '100%',
              padding: '0px 0px 20px 0px'
            }}>
              <CustomTablewithTotalInfoV2
                allowTableScroll={true}
                columns={[
                  {
                    headerName: "Order ID",
                    mappedValue: "orderNumber",
                    width: 120,
                    textAlign: "left",
                    renderCell: (value: any, row: any) => (
                      <div>
                        <div style={{ fontSize: '12px', color: '#666' }}>{row.orderNumber}</div>
                      </div>
                    )
                  },
                  {
                    headerName: "Outlet name & code", 
                    mappedValue: "outletName,outletCode",
                    width: 170,
                    textAlign: "left",
                    renderCell: (value: any, row: any) => (
                      <div>
                        <div style={{ fontWeight: 500, fontSize: '13px' }}>{row.outletName} {row.isKeyAccount && <StarsRoundedIcon
                          sx={{
                            color: "#FDB42C",
                            background: "#FFE8BF",
                            height: "15px",
                            width: "15px",
                            borderRadius: "50%",
                          }}
                        />}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>({row.outletCode})</div>
                      </div>
                    )
                  },
                  {
                    headerName: "Order date & time",
                    mappedValue: "orderDate",
                    width: 100,
                    textAlign: "left",
                    renderCell: (value: any, row: any) => (
                      <div>
                        <div style={{ fontSize: '13px' }}>{row.orderDate}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>{row.orderTime}</div>
                      </div>
                    )
                  },
                  {
                    headerName: "Ordered quantity",
                    mappedValue: "totalOrderedQuantity",
                    width: 180,
                    textAlign: "left",
                    renderCell: (value: any, row: any) => {
                      const caseUnitLabel = ConfigDictionary?.caseUnitLabel;
                      const otherUnitLabel = ConfigDictionary?.otherUnitLabel;
                      const packUnitLabel = ConfigDictionary?.packUnitLabel;
                      const {
                        uomConversion,
                        disableOtherUnitNameWiseCavinKair,
                        displayOtherUnitName,
                      } = ConfigDictionary;
                      let customOtherUnitLabel = displayOtherUnitName
                        ? row?.otherUnitName && row?.otherUnitName.length > 0
                          ? row?.otherUnitName
                          : otherUnitLabel
                        : otherUnitLabel;
                      const cs = `${row?.orderedCases}`
                      const pc = `${row?.orderedPieces}`
                      const oth = `${row?.orderedOthers}`
                      
                      return (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: '8px',
                          width: "min-content",
                          border: '1px solid #EEEEEE',
                          borderRadius: '4px',
                          padding: '8px'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px',color: "rgb(124, 124, 124)" }}>
                            <span style={{ fontSize: '12px', fontWeight: 500,}}>{cs}</span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{caseUnitLabel}</span>
                          </div>
                          <div style={{ width: '1px', height: '16px', backgroundColor: '#E0E0E0' }} />
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                            <span style={{ fontSize: '12px', fontWeight: 500}}>{oth}</span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{customOtherUnitLabel}</span>
                          </div>
                          <div style={{ width: '1px', height: '16px', backgroundColor: '#E0E0E0', color: "rgb(124, 124, 124)" }} />
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px', color: "rgb(124, 124, 124)" }}>
                            <span style={{ fontSize: '12px', fontWeight: 500, }}>{pc}</span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{packUnitLabel}</span>
                          </div>
                        </div>
                      );
                    }
                  },
                  {
                    headerName: "Allocated quantity",
                    mappedValue: "totalAllocatedQuantity",
                    width: 210,
                    textAlign: "left",
                    
                     renderCell: (value: any, row: any) => {
                      const caseUnitLabel = ConfigDictionary?.caseUnitLabel;
                      const otherUnitLabel = ConfigDictionary?.otherUnitLabel;
                      const packUnitLabel = ConfigDictionary?.packUnitLabel;
                      const {
                        uomConversion,
                        disableOtherUnitNameWiseCavinKair,
                        displayOtherUnitName,
                      } = ConfigDictionary;
                      const disableOtherUom: boolean =
                        (!row?.uom?.includes("all") && !row?.uom?.includes("other")) ||
                        (uomConversion && row?.otherToPieceQty === 0) ||
                        (disableOtherUnitNameWiseCavinKair &&
                          row?.otherUnitName?.trim().length === 0)
                      const disableCaseUom: boolean =
                        (!row?.uom?.includes("all") && !row?.uom?.includes("cs")) ||
                        (uomConversion && row?.caseToPieceQty === 0)
                      const disablePieceUom: boolean =
                        (!row?.uom?.includes("all") && !row?.uom?.includes("ea"))

                      let customOtherUnitLabel = displayOtherUnitName
                        ? row?.otherUnitName && row?.otherUnitName.length > 0
                          ? row?.otherUnitName
                          : otherUnitLabel
                        : otherUnitLabel;
                      const adjustQuantity = (
                        currentValue: number,
                        increment: number,
                        maxDigits: number = 4
                      ): number => {
                        const newValue: number = Math.max(0, currentValue + increment);
                        return newValue.toString().length <= maxDigits
                          ? newValue
                          : currentValue;
                      };
                     

                        return (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              opacity: 1, // dim the whole section for free items
                              pointerEvents: "auto", // block all clicks
                              justifyContent: "space-between"
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left",
                                position: "relative",
                                width: "min-content",
                                gap: "4px",
                                pointerEvents: "auto",
                              }}
                            >
              
                              {/* Case Quantity Input */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  position: "relative",
                                  background: disableCaseUom
                                    ? "#f5f5f5"
                                    : "#FAFAFB",
              
                                  border: disableCaseUom
                                    ? "1px solid #EEEEEE"
                                    : "1px solid #EEEEEE",
              
                                  borderRadius: "4px",
                                  minHeight: "35px",
                                  maxHeight: "35px",
                                  padding: "0px 0px 0px 4px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <input
                                    style={{
                                      width: `4ch`,
                                      padding: "0px",
                                      display: "inline-block",
                                      textAlign: "start",
                                      fontSize: "12px",
                                      borderRadius: "3px",
                                      color: disableCaseUom ? "#999" : "#7C7C7C",
                                      outline: "none",
                                      height: "auto", // don’t force input box height
                                      boxShadow: "none", // remove default browser shadow
                                      appearance: "none", // remove browser-specific styling
                                      border: "none",
                                      background: "transparent",
                                    }}
                                    disabled={disableCaseUom}
                                    value={row?.allocatedCases}
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      if (
                                        /^\d{0,4}$/.test(inputValue) &&
                                        !isNaN(+inputValue)
                                      ) {
                                        handleQuantityChange(row, +inputValue, UOM.CASE);
                                      }
                                    }}
                                    onBlur={() => {
                                      handleOnBlur(row);
                                    }}
                                  />
              
                                  {/* Label */}
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      color: disableCaseUom ? "#999" : "#666",
                                      marginRight: "2px",
                                    }}
                                  >
                                    {caseUnitLabel || "Cs"}
                                  </span>
                                </div>
              
                                {/* Increment / Decrement buttons */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: disableCaseUom ? 0.4 : 1, // fade when disabled
                                    pointerEvents: disableCaseUom ? "none" : "auto", // block clicks
                                    cursor: disableCaseUom ? "default" : "pointer",
                                  }}
                                >
                                  <ArrowDropUpRoundedIcon
                                    fontSize="small"
                                    viewBox="0 -6 24 24"
                                    sx={{
                                      cursor: !canEditOrder
                                        ? "not-allowed"
                                        : isEditing
                                        ? "default"
                                        : "pointer",
                                      pointerEvents: isEditing ? "auto" : "none",
                                    }}
                                    onClick={() => {
                                      if (!disableCaseUom) {
                                        const newValue: number = adjustQuantity(
                                          row?.allocatedCases || 0,
                                          1
                                        );
                                        updateQuantityAndBlur(row, newValue, UOM.CASE);
                                      }
                                    }}
                                  />
                                  <ArrowDropDownRoundedIcon
                                    fontSize="small"
                                    viewBox="0 6 24 24"
                                    sx={{
                                      cursor: !canEditOrder
                                        ? "not-allowed"
                                        : isEditing
                                        ? "default"
                                        : "pointer",
                                      pointerEvents: isEditing ? "auto" : "none",
                                    }}
                                    onClick={() => {
                                      if (!disableCaseUom) {
                                        const newValue: number = adjustQuantity(
                                          row?.allocatedCases || 0,
                                          -1
                                        );
                                        updateQuantityAndBlur(row, newValue, UOM.CASE);
                                      }
                                    }}
                                  />
                                </div>
                              </Box>
                              {/* Other Unit Quantity Input */}
                              {otherUnitLabel && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    position: "relative",
                                    background: disableOtherUom
                                      ? "#f5f5f5"
                                      : "#FAFAFB",
              
                                    border: disableOtherUom
                                      ? "1px solid #EEEEEE"
                                      : "1px solid #EEEEEE",
                                    borderRadius: "4px",
                                    minHeight: "35px",
                                    maxHeight: "35px",
                                    padding: "0px 0px 0px 4px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <input
                                      style={{
                                        padding: "0px",
                                        width: `4ch`,
              
                                        display: "inline-block",
                                        textAlign: "start",
                                        fontSize: "12px",
                                        borderRadius: "3px",
                                        color: disableOtherUom ? "#999" : "#7C7C7C",
                                        outline: "none",
                                        height: "auto", // inline-friendly
                                        boxShadow: "none", // remove browser shadow
                                        appearance: "none", // strip native styling
                                        border: "none",
                                        background: "transparent",
                                      }}
                                      disabled={disableOtherUom}
                                      value={row?.allocatedOthers ?? 0}
                                      onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (
                                          /^\d{0,4}$/.test(inputValue) &&
                                          !isNaN(+inputValue)
                                        ) {
                                          handleQuantityChange(row, +inputValue, UOM.OTHER);
                                        }
                                      }}
                                      onBlur={(e) => {
                                        let inputValue = e.target.value.trim();
                                        if (inputValue === "") {
                                          // user cleared → reset to 0
                                          inputValue = "0";
                                        }
                                        if (
                                          /^\d{0,4}$/.test(inputValue) &&
                                          !isNaN(+inputValue)
                                        ) {
                                          handleQuantityChange(row, +inputValue, UOM.OTHER);
                                        } else {
                                          // reset invalid
                                          e.target.value = String(
                                            row?.allocatedOthers ?? 0
                                          );
                                        }
                                        handleOnBlur(row);
                                      }}
                                    />
              
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        color: disableOtherUom ? "#999" : "#666",
                                        marginRight: "2px",
                                      }}
                                    >
                                      {customOtherUnitLabel || "Oth"}
                                    </span>
                                  </div>
              
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      opacity: disableOtherUom ? 0.4 : 1, // fade when disabled
                                      pointerEvents: disableOtherUom ? "none" : "auto", // block clicks
                                      cursor: disableOtherUom ? "default" : "pointer",
                                    }}
                                  >
                                    <ArrowDropUpRoundedIcon
                                      fontSize="small"
                                      viewBox="0 -6 24 24"
                                      sx={{
                                        cursor: !canEditOrder
                                        ? "not-allowed"
                                        : isEditing
                                        ? "default"
                                        : "pointer",
                                        pointerEvents: isEditing ? "auto" : "none",
                                      }}
                                      onClick={() => {
                                        if (!disableOtherUom) {
                                          const newValue: number = adjustQuantity(
                                            row?.allocatedOthers || 0,
                                            1
                                          );
                                          updateQuantityAndBlur(row, newValue, UOM.OTHER);
                                        }
                                      }}
                                    />
                                    <ArrowDropDownRoundedIcon
                                      fontSize="small"
                                      viewBox="0 6 24 24"
                                      sx={{
                                      cursor: !canEditOrder
                                        ? "not-allowed"
                                        : isEditing
                                        ? "default"
                                        : "pointer",
                                        pointerEvents: isEditing ? "auto" : "none",
                                      }}
                                      onClick={() => {
                                        if (!disableOtherUom) {
                                          const newValue: number = adjustQuantity(
                                            row?.allocatedOthers || 0,
                                            -1
                                          );
                                          updateQuantityAndBlur(row, newValue, UOM.OTHER);
                                        }
                                      }}
                                    />
                                  </div>
                                </Box>
                              )}
                              {/* Piece Quantity Input */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  position: "relative",
                                  background: disablePieceUom
                                    ? "#f5f5f5"
                                    : "#FAFAFB",
              
                                  border: disablePieceUom
                                    ? "1px solid #EEEEEE"
                                    : "1px solid #EEEEEE",
                                  borderRadius: "4px",
                                  minHeight: "35px",
                                  maxHeight: "35px",
                                  padding: "0px 0px 0px 4px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <input
                                    style={{
                                      padding: "0px",
                                      width: `4ch`,
                                      display: "inline-block",
                                      textAlign: "start",
                                      fontSize: "12px",
                                      borderRadius: "3px",
                                      color: disablePieceUom ? "#999" : "#7C7C7C",
                                      outline: "none",
                                      height: "auto",
                                      boxShadow: "none", // remove browser shadow
                                      appearance: "none", // remove native input styling
                                      border: "none",
                                      background: "transparent",
                                    }}
                                    disabled={disablePieceUom}
                                    value={row?.allocatedPieces ?? 0}
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      if (
                                        /^\d{0,4}$/.test(inputValue) &&
                                        !isNaN(+inputValue)
                                      ) {
                                        handleQuantityChange(row, +inputValue, UOM.PIECE);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      let inputValue = e.target.value.trim();
                                      if (inputValue === "") {
                                        // user cleared → reset to 0
                                        inputValue = "0";
                                      }
                                      if (
                                        /^\d{0,4}$/.test(inputValue) &&
                                        !isNaN(+inputValue)
                                      ) {
                                        handleQuantityChange(row, +inputValue, UOM.PIECE);
                                      } else {
                                        // reset invalid
                                        e.target.value = String(row?.allocatedPieces ?? 0);
                                      }
                                      handleOnBlur(row);
                                    }}
                                  />
              
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      color: disablePieceUom ? "#999" : "#666",
                                      marginRight: "2px",
                                    }}
                                  >
                                    {packUnitLabel}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: disablePieceUom ? 0.4 : 1, // faded when disabled
                                    pointerEvents: disablePieceUom ? "none" : "auto", // block clicks when disabled
                                    cursor: disablePieceUom ? "default" : "pointer",
                                  }}
                                >
                                  <ArrowDropUpRoundedIcon
                                    viewBox="0 -6 24 24"
                                    fontSize="small"
                                    sx={{
                                      cursor: !canEditOrder
                                        ? "not-allowed"
                                        : isEditing
                                        ? "default"
                                        : "pointer",
                                      pointerEvents: isEditing ? "auto" : "none",
                                    }}
                                    onClick={() => {
                                      if (!disablePieceUom) {
                                        const newValue: number = adjustQuantity(
                                          row?.allocatedPieces || 0,
                                          1
                                        );
                                        updateQuantityAndBlur(row, newValue, UOM.PIECE);
                                      }
                                    }}
                                  />
                                  <ArrowDropDownRoundedIcon
                                    viewBox="0 6 24 24"
                                    fontSize="small"
                                    sx={{
                                      cursor: !canEditOrder
                                        ? "not-allowed"
                                        : isEditing
                                        ? "default"
                                        : "pointer",
                                      pointerEvents: isEditing ? "auto" : "none",
                                    }}
                                    onClick={() => {
                                      if (!disablePieceUom) {
                                        const newValue: number = adjustQuantity(
                                          row?.allocatedPieces || 0,
                                          -1
                                        );
                                        updateQuantityAndBlur(row, newValue, UOM.PIECE);
                                      }
                                    }}
                                  />
                                </div>
                              </Box>
                            </Box>
                            <div
                              onClick={(e) => handleClick(e, row)}
                              style={{ cursor: "pointer", marginLeft: "4px" }}
                            >
                              <Fade in={(activeRow === null) || activeRow?.id !== row.id} timeout={150}>
                                <Box
                                  sx={{
                                    display: ((activeRow === null) || activeRow?.id !== row.id) ? "flex" : "none",
                                    transition: "transform 0.15s ease-in-out",
                                  }}
                                >
                                  <RenderSvg name="infoIconMSO" />
                                </Box>
                              </Fade>
                              <Fade in={(activeRow !== null) && activeRow?.id === row.id} timeout={150}>
                                <Box
                                  sx={{
                                    display: ((activeRow !== null) && activeRow?.id === row.id) ? "flex" : "none",
                                    transition: "transform 0.15s ease-in-out",
                                  }}
                                >
                                  <CloseIcon fontSize="small" />
                                </Box>
                              </Fade>
                            </div>
                          </div>
                        );
                      },
                  },
                  {
                    headerName: "Shortfall quantity",
                    mappedValue: "remainingQuantity",
                    width: 180,
                    textAlign: "left",
                    renderCell: (value: any, row: any) => {
            
                      
                      const cs = `${row?.stockExceedingCases}`
                      const pc = `${row?.stockExceedingPieces}`
                      const oth = `${row?.stockExceedingOthers}`
                      const caseUnitLabel = ConfigDictionary?.caseUnitLabel;
                      const otherUnitLabel = ConfigDictionary?.otherUnitLabel;
                      const packUnitLabel = ConfigDictionary?.packUnitLabel;
                      const {
                        uomConversion,
                        disableOtherUnitNameWiseCavinKair,
                        displayOtherUnitName,
                      } = ConfigDictionary;
                      let customOtherUnitLabel = displayOtherUnitName
                        ? row?.otherUnitName && row?.otherUnitName.length > 0
                          ? row?.otherUnitName
                          : otherUnitLabel
                        : otherUnitLabel;
                      return (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start', 
                          justifyContent: 'flex-start',
                          gap: '6px',
                          padding: '4px 8px',
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px',color: "rgb(124, 124, 124)" }}>
                            <span style={{ fontSize: '12px', fontWeight: 500,}}>{cs}</span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{caseUnitLabel}</span>
                          </div>
                          <div style={{ width: '1px', height: '16px', backgroundColor: '#E0E0E0' }} />
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                            <span style={{ fontSize: '12px', fontWeight: 500}}>{oth}</span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{customOtherUnitLabel}</span>
                          </div>
                          <div style={{ width: '1px', height: '16px', backgroundColor: '#E0E0E0', color: "rgb(124, 124, 124)" }} />
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px', color: "rgb(124, 124, 124)" }}>
                            <span style={{ fontSize: '12px', fontWeight: 500, }}>{pc}</span>
                            <span style={{ fontSize: '12px', color: '#999' }}>{packUnitLabel}</span>
                          </div>
                        </div>
                      );
                    }
                  },
                  {
                    headerName: "Credit status",
                    mappedValue: "creditStatus",
                    width: 180,
                    textAlign: "left",
                    renderCell: (value: any, row: any) => {
                      const calculatePercentage = (used: number, total: number): number => {
                        if (!total || total === 0) return 0;
                        return Math.round((used / total) * 100);
                      };
                      const creditUsed = ((row?.creditLimit ?? 0) - (row?.creditAvailable ?? 0)) || 0;
                      const creditTotal = row?.creditLimit || 0;
                      const percentage = calculatePercentage(creditUsed, creditTotal);

                      const getProgressColor = (percent: number): string => {
                        if (percent >= 90) return '#FF5722'; 
                        if (percent >= 75) return '#FF9800'; 
                        return '#00C6B1'; 
                      };

                      const progressColor = getProgressColor(percentage);
                      const statusText = `${percentage}% utilized`;

                      return (
                        <div style={{ display: 'flex', alignItems: 'center',gap: '8px' }}>
                          <span style={{ fontSize: '13px', fontWeight: 500 }}>{value}</span>
                          <div style={{ 
                            width: '60px', 
                            height: '4px', 
                            backgroundColor: '#E7E7E7', 
                            borderRadius: '2px',
                            overflow: 'hidden'
                          }}>
                            <div style={{ 
                              width: `${percentage}%`,
                              height: '100%',
                              backgroundColor: progressColor,
                              borderRadius: '2px',
                              transition: 'width 0.3s ease-in-out'
                            }} />
                          </div>
                          <span style={{ fontSize: '10px', color: '#666' }}>{statusText}</span>
                        </div>
                      );
                    }
                  }

                ]}
                data={filteredRows}
                totals={[]}
                headerBackgroundColor="#F0FBFF"
                isEditing={isEditing}
              >
                {/* Table Footer Buttons */}
                <div className="table-footer-buttons" style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  alignItems: 'center', 
                  padding: '16px 16px 24px 16px',
                  borderTop: '1px solid #E7E7E7',
                  backgroundColor: '#fff'
                }}>
                    <div style={{ display: 'flex', gap: '12px' }}>
                    {showResetButton && (
                      <Button 
                        variant="outlined"
                        onClick={handleResetAllocation}
                        disabled={!hasAnyChanges()}
                        sx={{ 
                          textTransform: 'none',
                          borderColor: '#ddd',
                          color: '#666',
                          fontSize: '14px',
                          padding: '6px 16px',
                          '&.Mui-disabled': {
                            borderColor: '#eee',
                            color: '#aaa',
                          },
                          '&:hover': {
                            borderColor: '#ccc'
                          }
                        }}
                      >
                        Reset
                      </Button>
                    )}
                    {showSaveButton && (
                      <Button 
                        variant="contained"

                        sx={{
                          textTransform: "none",
                          bgcolor: hasAnyChanges() ? "#00A392" : "#bdbdbd", // teal when active, grey when disabled
                          color: hasAnyChanges() ? "#fff" : "#666",
                          fontWeight: 600,
                          borderRadius: "8px",
                          px: 3,
                          py: 1.2,
                          boxShadow: hasAnyChanges()
                            ? "0px 3px 6px rgba(0, 163, 146, 0.4)"
                            : "none",
                          "&:hover": {
                            bgcolor: hasAnyChanges() ? "#008a7a" : "#bdbdbd",
                          },
                        }}
                        disabled={!hasAnyChanges()}
                        onClick={handleSaveAllocation}
                      >
                        Save allocation
                      </Button>
                    )}
                  </div>
                </div>
              </CustomTablewithTotalInfoV2>
              <Popper
                id={id} 
                open={popoverOpen}
                anchorEl={anchorEl}
                placement="bottom-start"
                transition
                style={{zIndex: 99999, padding: "12px"}}
                modifiers={[
                  { name: "offset", options: { offset: [0, 8] } },
                  { name: "preventOverflow", options: { padding: 8 } },
                ]}
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={150}>
                    <Paper
                      sx={{
                        borderRadius: "12px",
                        padding: "12px",
                        boxShadow: "0px 2px 12px rgba(0,0,0,0.15)",
                        minWidth: 360,
                        maxWidth: 420,
                      }}
                    >
                      {activeRow?.mergedRows && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                          {/* Header section */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 0,
                              p: 1,
                              borderRadius: "12px",
                              backgroundColor: "#FAFAFA"
                            }}
                          >
                            <Box>
                              <Tooltip title={activeRow?.mergedRows?.skuDescription || "SKU name unavailable"} arrow>
                                <Typography
                                  fontWeight={600}
                                  fontSize="12px"
                                  width="10rem"
                                  sx={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    cursor: "default", // show pointer if desired
                                  }}
                                >
                                  {activeRow?.mergedRows?.skuDescription || "SKU name unavailable"}
                                </Typography>
                              </Tooltip>
                              <Typography variant="body2" fontSize="12px" color="text.secondary">
                                ({activeRow?.mergedRows?.skuCode || "—"})
                              </Typography>
                            </Box>
                            <div style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              justifyContent: 'center',
                              gap: '8px',
                              width: "min-content",
                              border: '1px solid #EEEEEE',
                              borderRadius: '4px',
                              padding: '8px'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '2px',color: "rgb(124, 124, 124)" }}>
                                <span style={{ fontSize: '12px', fontWeight: 500,}}>{activeRow.mergedRows?.allocatedCases}</span>
                                <span style={{ fontSize: '12px', color: '#999' }}>{activeRow.mergedRows?.caseUnitLabel}</span>
                              </div>
                              <div style={{ width: '1px', height: '16px', backgroundColor: '#E0E0E0' }} />
                              <div style={{ display: 'flex', alignItems: 'center', gap: '2px',color: "rgb(124, 124, 124)"  }}>
                                <span style={{ fontSize: '12px', fontWeight: 500}}>{activeRow.mergedRows?.allocatedOthers}</span>
                                <span style={{ fontSize: '12px', color: '#999' }}>{activeRow.mergedRows?.otherUnitLabel}</span>
                              </div>
                              <div style={{ width: '1px', height: '16px', backgroundColor: '#E0E0E0', color: "rgb(124, 124, 124)" }} />
                              <div style={{ display: 'flex', alignItems: 'center', gap: '2px', color: "rgb(124, 124, 124)" }}>
                                <span style={{ fontSize: '12px', fontWeight: 500, }}>{activeRow.mergedRows?.allocatedPieces}</span>
                                <span style={{ fontSize: '12px', color: '#999' }}>{activeRow.mergedRows?.packUnitLabel}</span>
                              </div>
                            </div>
                          </Box>

                          <div>
                            <Typography fontSize="11px" color="text.secondary" sx={{ mb: 0.5 }}>
                              Replacement SKUs
                            </Typography>
                            <div
                              style={{
                                minHeight: "auto",
                                maxHeight: "140px",
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              {(() => {
                                const initialRepls = activeRow?.initialMergedRows?.replacements ?? [];
                                const updatedRepls = activeRow?.mergedRows?.replacements ?? [];

                                // map updated replacements by skuCode for quick lookup
                                const updatedBySku = new Map<string, any>();
                                updatedRepls.forEach((r: any) => {
                                  if (r?.skuCode) updatedBySku.set(r.skuCode, r);
                                });

                                const seen = new Set<string>();
                                const combined: any[] = [];

                                // Keep initial order first, but use latest quantities from updatedRepls (or 0 if missing)
                                initialRepls.forEach((r: any) => {
                                  seen.add(r.skuCode);
                                  const updated = updatedBySku.get(r.skuCode);
                                  combined.push({
                                    skuCode: r.skuCode,
                                    skuDescription: r.skuDescription,
                                    caseUnitLabel: r.caseUnitLabel,
                                    otherUnitLabel: r.otherUnitLabel,
                                    packUnitLabel: r.packUnitLabel,
                                    allocatedCases: updated?.allocatedCases ?? 0,
                                    allocatedOthers: updated?.allocatedOthers ?? 0,
                                    allocatedPieces: updated?.allocatedPieces ?? 0,
                                    isNew: false,
                                    wasRemovedFromUpdated: !updated,
                                  });
                                });

                                // Append any SKUs that are only present in updatedRepls (new SKUs)
                                updatedRepls.forEach((r: any) => {
                                  if (!seen.has(r.skuCode)) {
                                    seen.add(r.skuCode);
                                    combined.push({
                                      skuCode: r.skuCode,
                                      skuDescription: r.skuDescription,
                                      caseUnitLabel: r.caseUnitLabel,
                                      otherUnitLabel: r.otherUnitLabel,
                                      packUnitLabel: r.packUnitLabel,
                                      allocatedCases: r.allocatedCases ?? 0,
                                      allocatedOthers: r.allocatedOthers ?? 0,
                                      allocatedPieces: r.allocatedPieces ?? 0,
                                      isNew: true,
                                      wasRemovedFromUpdated: false,
                                    });
                                  }
                                });

                                if (!combined.length) {
                                  return <Typography variant="body2" color="text.secondary">No replacements</Typography>;
                                }

                                return combined.map((rep: any, i: number) => (
                                  <Box
                                    key={`${rep.skuCode}-${i}`}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      py: 1,
                                      borderBottom: i !== combined.length - 1 ? "1px dashed #eee" : "none",
                                    }}
                                  >
                                    <Box>
                                      <Tooltip title={rep.skuDescription || "SKU name unavailable"} arrow>
                                        <Typography
                                          fontSize="12px"
                                          color="#666666"
                                          fontWeight={500}
                                          width="10rem"
                                          sx={{
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            cursor: "default",
                                          }}
                                        >
                                          {rep.skuDescription}
                                        </Typography>
                                      </Tooltip>
                                      <Typography variant="body2" fontSize="12px" color="text.secondary">
                                        ({rep.skuCode})
                                      </Typography>
                                    </Box>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        width: "min-content",
                                        border: "1px solid #EEEEEE",
                                        borderRadius: "4px",
                                        padding: "8px",
                                      }}
                                    >
                                      <div style={{ display: "flex", alignItems: "center", gap: "2px", color: "rgb(124, 124, 124)" }}>
                                        <span style={{ fontSize: "12px", fontWeight: 500 }}>{rep.allocatedCases}</span>
                                        <span style={{ fontSize: "12px", color: "#999" }}>{rep.caseUnitLabel}</span>
                                      </div>

                                      <div style={{ width: "1px", height: "16px", backgroundColor: "#E0E0E0" }} />

                                      <div style={{ display: "flex", alignItems: "center", gap: "2px", color: "rgb(124, 124, 124)" }}>
                                        <span style={{ fontSize: "12px", fontWeight: 500 }}>{rep.allocatedOthers}</span>
                                        <span style={{ fontSize: "12px", color: "#999" }}>{rep.otherUnitLabel}</span>
                                      </div>

                                      <div style={{ width: "1px", height: "16px", backgroundColor: "#E0E0E0" }} />

                                      <div style={{ display: "flex", alignItems: "center", gap: "2px", color: "rgb(124, 124, 124)" }}>
                                        <span style={{ fontSize: "12px", fontWeight: 500 }}>{rep.allocatedPieces}</span>
                                        <span style={{ fontSize: "12px", color: "#999" }}>{rep.packUnitLabel}</span>
                                      </div>
                                    </div>
                                  </Box>
                                ));
                              })()}
                            </div>
                          </div>
                        </Box>
                      )}
                    </Paper>
                  </Fade>
                )}
              </Popper>

            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OutletWiseAllocationModal;
